/* eslint-disable */
// @ts-nocheck
// source: internal/job_progression.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_api_field_behavior_pb = require('../google/api/field_behavior_pb.js');
goog.object.extend(proto, google_api_field_behavior_pb);
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
goog.exportSymbol('proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TypeCase', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.TypeCase', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.GetJobProgressionRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.GetJobProgressionResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.GetManyJobProgressionsRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.GetManyJobProgressionsResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.GetManyProgressionErrorMessage', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.GetProgressionError', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobProgression', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobProgression.TypeCase', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobProgressionExtensionType', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobProgressionFlow', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobProgressionRealtimeEvent', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobProgressionStep', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.JobProgressionStepStatus', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.OverrideJobProgressionStepRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.OverrideableJobProgressionStepStatus', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ProgressionFound', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SetAuthorizationRequestedProgressionRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SetAuthorizationSignedProgressionRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SetDeliverableCompletedProgressionRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SetDraftApprovedProgressionRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SetDraftInReviewProgressionRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SetDraftRejectedProgressionRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SetExtensionAcceptedProgressionRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SetExtensionConfirmedProgressionRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SetExtensionRejectedProgressionRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SetJobStartedProgressionRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SetOpenItemsProgressionRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SetPreparationCompletedProgressionRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SetReadyToFileProgressionRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SetReturnFiledProgressionRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SetReviewCompletedProgressionRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.UpdateJobProgressionResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SetOpenItemsProgressionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.SetOpenItemsProgressionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SetOpenItemsProgressionRequest.displayName = 'proto.worklayer.internal.v1.SetOpenItemsProgressionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SetJobStartedProgressionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.SetJobStartedProgressionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SetJobStartedProgressionRequest.displayName = 'proto.worklayer.internal.v1.SetJobStartedProgressionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SetDraftInReviewProgressionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.SetDraftInReviewProgressionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SetDraftInReviewProgressionRequest.displayName = 'proto.worklayer.internal.v1.SetDraftInReviewProgressionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SetDraftApprovedProgressionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.SetDraftApprovedProgressionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SetDraftApprovedProgressionRequest.displayName = 'proto.worklayer.internal.v1.SetDraftApprovedProgressionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SetDraftRejectedProgressionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.SetDraftRejectedProgressionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SetDraftRejectedProgressionRequest.displayName = 'proto.worklayer.internal.v1.SetDraftRejectedProgressionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SetAuthorizationRequestedProgressionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.SetAuthorizationRequestedProgressionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SetAuthorizationRequestedProgressionRequest.displayName = 'proto.worklayer.internal.v1.SetAuthorizationRequestedProgressionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SetAuthorizationSignedProgressionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.SetAuthorizationSignedProgressionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SetAuthorizationSignedProgressionRequest.displayName = 'proto.worklayer.internal.v1.SetAuthorizationSignedProgressionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SetReturnFiledProgressionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.SetReturnFiledProgressionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SetReturnFiledProgressionRequest.displayName = 'proto.worklayer.internal.v1.SetReturnFiledProgressionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SetPreparationCompletedProgressionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.SetPreparationCompletedProgressionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SetPreparationCompletedProgressionRequest.displayName = 'proto.worklayer.internal.v1.SetPreparationCompletedProgressionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SetReviewCompletedProgressionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.SetReviewCompletedProgressionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SetReviewCompletedProgressionRequest.displayName = 'proto.worklayer.internal.v1.SetReviewCompletedProgressionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SetDeliverableCompletedProgressionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.SetDeliverableCompletedProgressionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SetDeliverableCompletedProgressionRequest.displayName = 'proto.worklayer.internal.v1.SetDeliverableCompletedProgressionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest.displayName = 'proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SetExtensionAcceptedProgressionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.SetExtensionAcceptedProgressionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SetExtensionAcceptedProgressionRequest.displayName = 'proto.worklayer.internal.v1.SetExtensionAcceptedProgressionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SetExtensionConfirmedProgressionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.SetExtensionConfirmedProgressionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SetExtensionConfirmedProgressionRequest.displayName = 'proto.worklayer.internal.v1.SetExtensionConfirmedProgressionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SetExtensionRejectedProgressionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.SetExtensionRejectedProgressionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SetExtensionRejectedProgressionRequest.displayName = 'proto.worklayer.internal.v1.SetExtensionRejectedProgressionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SetReadyToFileProgressionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.SetReadyToFileProgressionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SetReadyToFileProgressionRequest.displayName = 'proto.worklayer.internal.v1.SetReadyToFileProgressionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.GetJobProgressionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.GetJobProgressionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.GetJobProgressionRequest.displayName = 'proto.worklayer.internal.v1.GetJobProgressionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.GetJobProgressionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.GetJobProgressionResponse.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.GetJobProgressionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.GetJobProgressionResponse.displayName = 'proto.worklayer.internal.v1.GetJobProgressionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.GetManyJobProgressionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.GetManyJobProgressionsRequest.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.GetManyJobProgressionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.GetManyJobProgressionsRequest.displayName = 'proto.worklayer.internal.v1.GetManyJobProgressionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.GetManyJobProgressionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.GetManyJobProgressionsResponse.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.GetManyJobProgressionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.GetManyJobProgressionsResponse.displayName = 'proto.worklayer.internal.v1.GetManyJobProgressionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.OverrideJobProgressionStepRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.OverrideJobProgressionStepRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.OverrideJobProgressionStepRequest.displayName = 'proto.worklayer.internal.v1.OverrideJobProgressionStepRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.JobProgression = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.worklayer.internal.v1.JobProgression.oneofGroups_);
};
goog.inherits(proto.worklayer.internal.v1.JobProgression, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.JobProgression.displayName = 'proto.worklayer.internal.v1.JobProgression';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.UpdateJobProgressionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.UpdateJobProgressionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.UpdateJobProgressionResponse.displayName = 'proto.worklayer.internal.v1.UpdateJobProgressionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobRequest.displayName = 'proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.oneofGroups_);
};
goog.inherits(proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.displayName = 'proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.oneofGroups_);
};
goog.inherits(proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.displayName = 'proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension.displayName = 'proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ProgressionFound = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.ProgressionFound.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.ProgressionFound, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ProgressionFound.displayName = 'proto.worklayer.internal.v1.ProgressionFound';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.GetProgressionError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.GetProgressionError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.GetProgressionError.displayName = 'proto.worklayer.internal.v1.GetProgressionError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.JobProgressionStep = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.JobProgressionStep, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.JobProgressionStep.displayName = 'proto.worklayer.internal.v1.JobProgressionStep';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.JobProgressionRealtimeEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.JobProgressionRealtimeEvent.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.JobProgressionRealtimeEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.JobProgressionRealtimeEvent.displayName = 'proto.worklayer.internal.v1.JobProgressionRealtimeEvent';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SetOpenItemsProgressionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SetOpenItemsProgressionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SetOpenItemsProgressionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetOpenItemsProgressionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SetOpenItemsProgressionRequest}
 */
proto.worklayer.internal.v1.SetOpenItemsProgressionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SetOpenItemsProgressionRequest;
  return proto.worklayer.internal.v1.SetOpenItemsProgressionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SetOpenItemsProgressionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SetOpenItemsProgressionRequest}
 */
proto.worklayer.internal.v1.SetOpenItemsProgressionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SetOpenItemsProgressionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SetOpenItemsProgressionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SetOpenItemsProgressionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetOpenItemsProgressionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.SetOpenItemsProgressionRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SetOpenItemsProgressionRequest} returns this
 */
proto.worklayer.internal.v1.SetOpenItemsProgressionRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SetJobStartedProgressionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SetJobStartedProgressionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SetJobStartedProgressionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetJobStartedProgressionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SetJobStartedProgressionRequest}
 */
proto.worklayer.internal.v1.SetJobStartedProgressionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SetJobStartedProgressionRequest;
  return proto.worklayer.internal.v1.SetJobStartedProgressionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SetJobStartedProgressionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SetJobStartedProgressionRequest}
 */
proto.worklayer.internal.v1.SetJobStartedProgressionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SetJobStartedProgressionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SetJobStartedProgressionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SetJobStartedProgressionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetJobStartedProgressionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.SetJobStartedProgressionRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SetJobStartedProgressionRequest} returns this
 */
proto.worklayer.internal.v1.SetJobStartedProgressionRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SetDraftInReviewProgressionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SetDraftInReviewProgressionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SetDraftInReviewProgressionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetDraftInReviewProgressionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SetDraftInReviewProgressionRequest}
 */
proto.worklayer.internal.v1.SetDraftInReviewProgressionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SetDraftInReviewProgressionRequest;
  return proto.worklayer.internal.v1.SetDraftInReviewProgressionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SetDraftInReviewProgressionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SetDraftInReviewProgressionRequest}
 */
proto.worklayer.internal.v1.SetDraftInReviewProgressionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SetDraftInReviewProgressionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SetDraftInReviewProgressionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SetDraftInReviewProgressionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetDraftInReviewProgressionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.SetDraftInReviewProgressionRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SetDraftInReviewProgressionRequest} returns this
 */
proto.worklayer.internal.v1.SetDraftInReviewProgressionRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SetDraftApprovedProgressionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SetDraftApprovedProgressionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SetDraftApprovedProgressionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetDraftApprovedProgressionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SetDraftApprovedProgressionRequest}
 */
proto.worklayer.internal.v1.SetDraftApprovedProgressionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SetDraftApprovedProgressionRequest;
  return proto.worklayer.internal.v1.SetDraftApprovedProgressionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SetDraftApprovedProgressionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SetDraftApprovedProgressionRequest}
 */
proto.worklayer.internal.v1.SetDraftApprovedProgressionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SetDraftApprovedProgressionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SetDraftApprovedProgressionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SetDraftApprovedProgressionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetDraftApprovedProgressionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.SetDraftApprovedProgressionRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SetDraftApprovedProgressionRequest} returns this
 */
proto.worklayer.internal.v1.SetDraftApprovedProgressionRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SetDraftRejectedProgressionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SetDraftRejectedProgressionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SetDraftRejectedProgressionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetDraftRejectedProgressionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SetDraftRejectedProgressionRequest}
 */
proto.worklayer.internal.v1.SetDraftRejectedProgressionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SetDraftRejectedProgressionRequest;
  return proto.worklayer.internal.v1.SetDraftRejectedProgressionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SetDraftRejectedProgressionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SetDraftRejectedProgressionRequest}
 */
proto.worklayer.internal.v1.SetDraftRejectedProgressionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SetDraftRejectedProgressionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SetDraftRejectedProgressionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SetDraftRejectedProgressionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetDraftRejectedProgressionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.SetDraftRejectedProgressionRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SetDraftRejectedProgressionRequest} returns this
 */
proto.worklayer.internal.v1.SetDraftRejectedProgressionRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SetAuthorizationRequestedProgressionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SetAuthorizationRequestedProgressionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SetAuthorizationRequestedProgressionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetAuthorizationRequestedProgressionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SetAuthorizationRequestedProgressionRequest}
 */
proto.worklayer.internal.v1.SetAuthorizationRequestedProgressionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SetAuthorizationRequestedProgressionRequest;
  return proto.worklayer.internal.v1.SetAuthorizationRequestedProgressionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SetAuthorizationRequestedProgressionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SetAuthorizationRequestedProgressionRequest}
 */
proto.worklayer.internal.v1.SetAuthorizationRequestedProgressionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SetAuthorizationRequestedProgressionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SetAuthorizationRequestedProgressionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SetAuthorizationRequestedProgressionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetAuthorizationRequestedProgressionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.SetAuthorizationRequestedProgressionRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SetAuthorizationRequestedProgressionRequest} returns this
 */
proto.worklayer.internal.v1.SetAuthorizationRequestedProgressionRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SetAuthorizationSignedProgressionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SetAuthorizationSignedProgressionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SetAuthorizationSignedProgressionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetAuthorizationSignedProgressionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SetAuthorizationSignedProgressionRequest}
 */
proto.worklayer.internal.v1.SetAuthorizationSignedProgressionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SetAuthorizationSignedProgressionRequest;
  return proto.worklayer.internal.v1.SetAuthorizationSignedProgressionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SetAuthorizationSignedProgressionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SetAuthorizationSignedProgressionRequest}
 */
proto.worklayer.internal.v1.SetAuthorizationSignedProgressionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SetAuthorizationSignedProgressionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SetAuthorizationSignedProgressionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SetAuthorizationSignedProgressionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetAuthorizationSignedProgressionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.SetAuthorizationSignedProgressionRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SetAuthorizationSignedProgressionRequest} returns this
 */
proto.worklayer.internal.v1.SetAuthorizationSignedProgressionRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SetReturnFiledProgressionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SetReturnFiledProgressionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SetReturnFiledProgressionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetReturnFiledProgressionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SetReturnFiledProgressionRequest}
 */
proto.worklayer.internal.v1.SetReturnFiledProgressionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SetReturnFiledProgressionRequest;
  return proto.worklayer.internal.v1.SetReturnFiledProgressionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SetReturnFiledProgressionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SetReturnFiledProgressionRequest}
 */
proto.worklayer.internal.v1.SetReturnFiledProgressionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SetReturnFiledProgressionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SetReturnFiledProgressionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SetReturnFiledProgressionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetReturnFiledProgressionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.SetReturnFiledProgressionRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SetReturnFiledProgressionRequest} returns this
 */
proto.worklayer.internal.v1.SetReturnFiledProgressionRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SetPreparationCompletedProgressionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SetPreparationCompletedProgressionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SetPreparationCompletedProgressionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetPreparationCompletedProgressionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SetPreparationCompletedProgressionRequest}
 */
proto.worklayer.internal.v1.SetPreparationCompletedProgressionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SetPreparationCompletedProgressionRequest;
  return proto.worklayer.internal.v1.SetPreparationCompletedProgressionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SetPreparationCompletedProgressionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SetPreparationCompletedProgressionRequest}
 */
proto.worklayer.internal.v1.SetPreparationCompletedProgressionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SetPreparationCompletedProgressionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SetPreparationCompletedProgressionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SetPreparationCompletedProgressionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetPreparationCompletedProgressionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.SetPreparationCompletedProgressionRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SetPreparationCompletedProgressionRequest} returns this
 */
proto.worklayer.internal.v1.SetPreparationCompletedProgressionRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SetReviewCompletedProgressionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SetReviewCompletedProgressionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SetReviewCompletedProgressionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetReviewCompletedProgressionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SetReviewCompletedProgressionRequest}
 */
proto.worklayer.internal.v1.SetReviewCompletedProgressionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SetReviewCompletedProgressionRequest;
  return proto.worklayer.internal.v1.SetReviewCompletedProgressionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SetReviewCompletedProgressionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SetReviewCompletedProgressionRequest}
 */
proto.worklayer.internal.v1.SetReviewCompletedProgressionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SetReviewCompletedProgressionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SetReviewCompletedProgressionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SetReviewCompletedProgressionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetReviewCompletedProgressionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.SetReviewCompletedProgressionRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SetReviewCompletedProgressionRequest} returns this
 */
proto.worklayer.internal.v1.SetReviewCompletedProgressionRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SetDeliverableCompletedProgressionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SetDeliverableCompletedProgressionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SetDeliverableCompletedProgressionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetDeliverableCompletedProgressionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SetDeliverableCompletedProgressionRequest}
 */
proto.worklayer.internal.v1.SetDeliverableCompletedProgressionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SetDeliverableCompletedProgressionRequest;
  return proto.worklayer.internal.v1.SetDeliverableCompletedProgressionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SetDeliverableCompletedProgressionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SetDeliverableCompletedProgressionRequest}
 */
proto.worklayer.internal.v1.SetDeliverableCompletedProgressionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SetDeliverableCompletedProgressionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SetDeliverableCompletedProgressionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SetDeliverableCompletedProgressionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetDeliverableCompletedProgressionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.SetDeliverableCompletedProgressionRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SetDeliverableCompletedProgressionRequest} returns this
 */
proto.worklayer.internal.v1.SetDeliverableCompletedProgressionRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    extensionType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest}
 */
proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest;
  return proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest}
 */
proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 2:
      var value = /** @type {!proto.worklayer.internal.v1.JobProgressionExtensionType} */ (reader.readEnum());
      msg.setExtensionType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExtensionType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest} returns this
 */
proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional JobProgressionExtensionType extension_type = 2;
 * @return {!proto.worklayer.internal.v1.JobProgressionExtensionType}
 */
proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest.prototype.getExtensionType = function() {
  return /** @type {!proto.worklayer.internal.v1.JobProgressionExtensionType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.JobProgressionExtensionType} value
 * @return {!proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest} returns this
 */
proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest.prototype.setExtensionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SetExtensionAcceptedProgressionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SetExtensionAcceptedProgressionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SetExtensionAcceptedProgressionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetExtensionAcceptedProgressionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SetExtensionAcceptedProgressionRequest}
 */
proto.worklayer.internal.v1.SetExtensionAcceptedProgressionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SetExtensionAcceptedProgressionRequest;
  return proto.worklayer.internal.v1.SetExtensionAcceptedProgressionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SetExtensionAcceptedProgressionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SetExtensionAcceptedProgressionRequest}
 */
proto.worklayer.internal.v1.SetExtensionAcceptedProgressionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SetExtensionAcceptedProgressionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SetExtensionAcceptedProgressionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SetExtensionAcceptedProgressionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetExtensionAcceptedProgressionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.SetExtensionAcceptedProgressionRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SetExtensionAcceptedProgressionRequest} returns this
 */
proto.worklayer.internal.v1.SetExtensionAcceptedProgressionRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SetExtensionConfirmedProgressionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SetExtensionConfirmedProgressionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SetExtensionConfirmedProgressionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetExtensionConfirmedProgressionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SetExtensionConfirmedProgressionRequest}
 */
proto.worklayer.internal.v1.SetExtensionConfirmedProgressionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SetExtensionConfirmedProgressionRequest;
  return proto.worklayer.internal.v1.SetExtensionConfirmedProgressionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SetExtensionConfirmedProgressionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SetExtensionConfirmedProgressionRequest}
 */
proto.worklayer.internal.v1.SetExtensionConfirmedProgressionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SetExtensionConfirmedProgressionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SetExtensionConfirmedProgressionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SetExtensionConfirmedProgressionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetExtensionConfirmedProgressionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.SetExtensionConfirmedProgressionRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SetExtensionConfirmedProgressionRequest} returns this
 */
proto.worklayer.internal.v1.SetExtensionConfirmedProgressionRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SetExtensionRejectedProgressionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SetExtensionRejectedProgressionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SetExtensionRejectedProgressionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetExtensionRejectedProgressionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SetExtensionRejectedProgressionRequest}
 */
proto.worklayer.internal.v1.SetExtensionRejectedProgressionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SetExtensionRejectedProgressionRequest;
  return proto.worklayer.internal.v1.SetExtensionRejectedProgressionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SetExtensionRejectedProgressionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SetExtensionRejectedProgressionRequest}
 */
proto.worklayer.internal.v1.SetExtensionRejectedProgressionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SetExtensionRejectedProgressionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SetExtensionRejectedProgressionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SetExtensionRejectedProgressionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetExtensionRejectedProgressionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.SetExtensionRejectedProgressionRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SetExtensionRejectedProgressionRequest} returns this
 */
proto.worklayer.internal.v1.SetExtensionRejectedProgressionRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SetReadyToFileProgressionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SetReadyToFileProgressionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SetReadyToFileProgressionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetReadyToFileProgressionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    setAsAdmin: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SetReadyToFileProgressionRequest}
 */
proto.worklayer.internal.v1.SetReadyToFileProgressionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SetReadyToFileProgressionRequest;
  return proto.worklayer.internal.v1.SetReadyToFileProgressionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SetReadyToFileProgressionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SetReadyToFileProgressionRequest}
 */
proto.worklayer.internal.v1.SetReadyToFileProgressionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSetAsAdmin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SetReadyToFileProgressionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SetReadyToFileProgressionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SetReadyToFileProgressionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetReadyToFileProgressionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSetAsAdmin();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.SetReadyToFileProgressionRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SetReadyToFileProgressionRequest} returns this
 */
proto.worklayer.internal.v1.SetReadyToFileProgressionRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool set_as_admin = 2;
 * @return {boolean}
 */
proto.worklayer.internal.v1.SetReadyToFileProgressionRequest.prototype.getSetAsAdmin = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.SetReadyToFileProgressionRequest} returns this
 */
proto.worklayer.internal.v1.SetReadyToFileProgressionRequest.prototype.setSetAsAdmin = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.GetJobProgressionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.GetJobProgressionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.GetJobProgressionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetJobProgressionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.GetJobProgressionRequest}
 */
proto.worklayer.internal.v1.GetJobProgressionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.GetJobProgressionRequest;
  return proto.worklayer.internal.v1.GetJobProgressionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.GetJobProgressionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.GetJobProgressionRequest}
 */
proto.worklayer.internal.v1.GetJobProgressionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.GetJobProgressionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.GetJobProgressionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.GetJobProgressionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetJobProgressionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.GetJobProgressionRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.GetJobProgressionRequest} returns this
 */
proto.worklayer.internal.v1.GetJobProgressionRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.GetJobProgressionResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.GetJobProgressionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.GetJobProgressionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.GetJobProgressionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetJobProgressionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    progressionStepsList: jspb.Message.toObjectList(msg.getProgressionStepsList(),
    proto.worklayer.internal.v1.JobProgressionStep.toObject, includeInstance),
    progressionFlow: jspb.Message.getFieldWithDefault(msg, 2, 0),
    id: jspb.Message.getFieldWithDefault(msg, 3, ""),
    canChoosePersonalOrBusinessExtension: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    jobId: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.GetJobProgressionResponse}
 */
proto.worklayer.internal.v1.GetJobProgressionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.GetJobProgressionResponse;
  return proto.worklayer.internal.v1.GetJobProgressionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.GetJobProgressionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.GetJobProgressionResponse}
 */
proto.worklayer.internal.v1.GetJobProgressionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.JobProgressionStep;
      reader.readMessage(value,proto.worklayer.internal.v1.JobProgressionStep.deserializeBinaryFromReader);
      msg.addProgressionSteps(value);
      break;
    case 2:
      var value = /** @type {!proto.worklayer.internal.v1.JobProgressionFlow} */ (reader.readEnum());
      msg.setProgressionFlow(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanChoosePersonalOrBusinessExtension(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.GetJobProgressionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.GetJobProgressionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.GetJobProgressionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetJobProgressionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProgressionStepsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.worklayer.internal.v1.JobProgressionStep.serializeBinaryToWriter
    );
  }
  f = message.getProgressionFlow();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCanChoosePersonalOrBusinessExtension();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * repeated JobProgressionStep progression_steps = 1;
 * @return {!Array<!proto.worklayer.internal.v1.JobProgressionStep>}
 */
proto.worklayer.internal.v1.GetJobProgressionResponse.prototype.getProgressionStepsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.JobProgressionStep>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.JobProgressionStep, 1));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.JobProgressionStep>} value
 * @return {!proto.worklayer.internal.v1.GetJobProgressionResponse} returns this
*/
proto.worklayer.internal.v1.GetJobProgressionResponse.prototype.setProgressionStepsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.worklayer.internal.v1.JobProgressionStep=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.JobProgressionStep}
 */
proto.worklayer.internal.v1.GetJobProgressionResponse.prototype.addProgressionSteps = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.worklayer.internal.v1.JobProgressionStep, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.GetJobProgressionResponse} returns this
 */
proto.worklayer.internal.v1.GetJobProgressionResponse.prototype.clearProgressionStepsList = function() {
  return this.setProgressionStepsList([]);
};


/**
 * optional JobProgressionFlow progression_flow = 2;
 * @return {!proto.worklayer.internal.v1.JobProgressionFlow}
 */
proto.worklayer.internal.v1.GetJobProgressionResponse.prototype.getProgressionFlow = function() {
  return /** @type {!proto.worklayer.internal.v1.JobProgressionFlow} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.JobProgressionFlow} value
 * @return {!proto.worklayer.internal.v1.GetJobProgressionResponse} returns this
 */
proto.worklayer.internal.v1.GetJobProgressionResponse.prototype.setProgressionFlow = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string id = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.GetJobProgressionResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.GetJobProgressionResponse} returns this
 */
proto.worklayer.internal.v1.GetJobProgressionResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool can_choose_personal_or_business_extension = 4;
 * @return {boolean}
 */
proto.worklayer.internal.v1.GetJobProgressionResponse.prototype.getCanChoosePersonalOrBusinessExtension = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.GetJobProgressionResponse} returns this
 */
proto.worklayer.internal.v1.GetJobProgressionResponse.prototype.setCanChoosePersonalOrBusinessExtension = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string job_id = 5;
 * @return {string}
 */
proto.worklayer.internal.v1.GetJobProgressionResponse.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.GetJobProgressionResponse} returns this
 */
proto.worklayer.internal.v1.GetJobProgressionResponse.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.GetManyJobProgressionsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.GetManyJobProgressionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.GetManyJobProgressionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.GetManyJobProgressionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetManyJobProgressionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.GetManyJobProgressionsRequest}
 */
proto.worklayer.internal.v1.GetManyJobProgressionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.GetManyJobProgressionsRequest;
  return proto.worklayer.internal.v1.GetManyJobProgressionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.GetManyJobProgressionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.GetManyJobProgressionsRequest}
 */
proto.worklayer.internal.v1.GetManyJobProgressionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addJobIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.GetManyJobProgressionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.GetManyJobProgressionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.GetManyJobProgressionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetManyJobProgressionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string job_ids = 1;
 * @return {!Array<string>}
 */
proto.worklayer.internal.v1.GetManyJobProgressionsRequest.prototype.getJobIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.worklayer.internal.v1.GetManyJobProgressionsRequest} returns this
 */
proto.worklayer.internal.v1.GetManyJobProgressionsRequest.prototype.setJobIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.GetManyJobProgressionsRequest} returns this
 */
proto.worklayer.internal.v1.GetManyJobProgressionsRequest.prototype.addJobIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.GetManyJobProgressionsRequest} returns this
 */
proto.worklayer.internal.v1.GetManyJobProgressionsRequest.prototype.clearJobIdsList = function() {
  return this.setJobIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.GetManyJobProgressionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.GetManyJobProgressionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.GetManyJobProgressionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.GetManyJobProgressionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetManyJobProgressionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    progressionsList: jspb.Message.toObjectList(msg.getProgressionsList(),
    proto.worklayer.internal.v1.JobProgression.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.GetManyJobProgressionsResponse}
 */
proto.worklayer.internal.v1.GetManyJobProgressionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.GetManyJobProgressionsResponse;
  return proto.worklayer.internal.v1.GetManyJobProgressionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.GetManyJobProgressionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.GetManyJobProgressionsResponse}
 */
proto.worklayer.internal.v1.GetManyJobProgressionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.JobProgression;
      reader.readMessage(value,proto.worklayer.internal.v1.JobProgression.deserializeBinaryFromReader);
      msg.addProgressions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.GetManyJobProgressionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.GetManyJobProgressionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.GetManyJobProgressionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetManyJobProgressionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProgressionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.worklayer.internal.v1.JobProgression.serializeBinaryToWriter
    );
  }
};


/**
 * repeated JobProgression progressions = 1;
 * @return {!Array<!proto.worklayer.internal.v1.JobProgression>}
 */
proto.worklayer.internal.v1.GetManyJobProgressionsResponse.prototype.getProgressionsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.JobProgression>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.JobProgression, 1));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.JobProgression>} value
 * @return {!proto.worklayer.internal.v1.GetManyJobProgressionsResponse} returns this
*/
proto.worklayer.internal.v1.GetManyJobProgressionsResponse.prototype.setProgressionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.worklayer.internal.v1.JobProgression=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.JobProgression}
 */
proto.worklayer.internal.v1.GetManyJobProgressionsResponse.prototype.addProgressions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.worklayer.internal.v1.JobProgression, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.GetManyJobProgressionsResponse} returns this
 */
proto.worklayer.internal.v1.GetManyJobProgressionsResponse.prototype.clearProgressionsList = function() {
  return this.setProgressionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.OverrideJobProgressionStepRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.OverrideJobProgressionStepRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.OverrideJobProgressionStepRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.OverrideJobProgressionStepRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    progressionStep: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.OverrideJobProgressionStepRequest}
 */
proto.worklayer.internal.v1.OverrideJobProgressionStepRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.OverrideJobProgressionStepRequest;
  return proto.worklayer.internal.v1.OverrideJobProgressionStepRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.OverrideJobProgressionStepRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.OverrideJobProgressionStepRequest}
 */
proto.worklayer.internal.v1.OverrideJobProgressionStepRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 2:
      var value = /** @type {!proto.worklayer.internal.v1.OverrideableJobProgressionStepStatus} */ (reader.readEnum());
      msg.setProgressionStep(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.OverrideJobProgressionStepRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.OverrideJobProgressionStepRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.OverrideJobProgressionStepRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.OverrideJobProgressionStepRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProgressionStep();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.OverrideJobProgressionStepRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.OverrideJobProgressionStepRequest} returns this
 */
proto.worklayer.internal.v1.OverrideJobProgressionStepRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional OverrideableJobProgressionStepStatus progression_step = 2;
 * @return {!proto.worklayer.internal.v1.OverrideableJobProgressionStepStatus}
 */
proto.worklayer.internal.v1.OverrideJobProgressionStepRequest.prototype.getProgressionStep = function() {
  return /** @type {!proto.worklayer.internal.v1.OverrideableJobProgressionStepStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.OverrideableJobProgressionStepStatus} value
 * @return {!proto.worklayer.internal.v1.OverrideJobProgressionStepRequest} returns this
 */
proto.worklayer.internal.v1.OverrideJobProgressionStepRequest.prototype.setProgressionStep = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.worklayer.internal.v1.JobProgression.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.JobProgression.TypeCase = {
  TYPE_NOT_SET: 0,
  PROGRESSION: 2,
  PROGRESSION_ERROR: 3
};

/**
 * @return {proto.worklayer.internal.v1.JobProgression.TypeCase}
 */
proto.worklayer.internal.v1.JobProgression.prototype.getTypeCase = function() {
  return /** @type {proto.worklayer.internal.v1.JobProgression.TypeCase} */(jspb.Message.computeOneofCase(this, proto.worklayer.internal.v1.JobProgression.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.JobProgression.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.JobProgression.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.JobProgression} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobProgression.toObject = function(includeInstance, msg) {
  var f, obj = {
    progression: (f = msg.getProgression()) && proto.worklayer.internal.v1.ProgressionFound.toObject(includeInstance, f),
    progressionError: (f = msg.getProgressionError()) && proto.worklayer.internal.v1.GetProgressionError.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.JobProgression}
 */
proto.worklayer.internal.v1.JobProgression.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.JobProgression;
  return proto.worklayer.internal.v1.JobProgression.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.JobProgression} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.JobProgression}
 */
proto.worklayer.internal.v1.JobProgression.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new proto.worklayer.internal.v1.ProgressionFound;
      reader.readMessage(value,proto.worklayer.internal.v1.ProgressionFound.deserializeBinaryFromReader);
      msg.setProgression(value);
      break;
    case 3:
      var value = new proto.worklayer.internal.v1.GetProgressionError;
      reader.readMessage(value,proto.worklayer.internal.v1.GetProgressionError.deserializeBinaryFromReader);
      msg.setProgressionError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.JobProgression.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.JobProgression.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.JobProgression} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobProgression.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProgression();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.v1.ProgressionFound.serializeBinaryToWriter
    );
  }
  f = message.getProgressionError();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.worklayer.internal.v1.GetProgressionError.serializeBinaryToWriter
    );
  }
};


/**
 * optional ProgressionFound progression = 2;
 * @return {?proto.worklayer.internal.v1.ProgressionFound}
 */
proto.worklayer.internal.v1.JobProgression.prototype.getProgression = function() {
  return /** @type{?proto.worklayer.internal.v1.ProgressionFound} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.ProgressionFound, 2));
};


/**
 * @param {?proto.worklayer.internal.v1.ProgressionFound|undefined} value
 * @return {!proto.worklayer.internal.v1.JobProgression} returns this
*/
proto.worklayer.internal.v1.JobProgression.prototype.setProgression = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.worklayer.internal.v1.JobProgression.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobProgression} returns this
 */
proto.worklayer.internal.v1.JobProgression.prototype.clearProgression = function() {
  return this.setProgression(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobProgression.prototype.hasProgression = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional GetProgressionError progression_error = 3;
 * @return {?proto.worklayer.internal.v1.GetProgressionError}
 */
proto.worklayer.internal.v1.JobProgression.prototype.getProgressionError = function() {
  return /** @type{?proto.worklayer.internal.v1.GetProgressionError} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.GetProgressionError, 3));
};


/**
 * @param {?proto.worklayer.internal.v1.GetProgressionError|undefined} value
 * @return {!proto.worklayer.internal.v1.JobProgression} returns this
*/
proto.worklayer.internal.v1.JobProgression.prototype.setProgressionError = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.worklayer.internal.v1.JobProgression.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobProgression} returns this
 */
proto.worklayer.internal.v1.JobProgression.prototype.clearProgressionError = function() {
  return this.setProgressionError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobProgression.prototype.hasProgressionError = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.UpdateJobProgressionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.UpdateJobProgressionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.UpdateJobProgressionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.UpdateJobProgressionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    progressionStep: jspb.Message.getFieldWithDefault(msg, 2, 0),
    updateTime: (f = msg.getUpdateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.UpdateJobProgressionResponse}
 */
proto.worklayer.internal.v1.UpdateJobProgressionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.UpdateJobProgressionResponse;
  return proto.worklayer.internal.v1.UpdateJobProgressionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.UpdateJobProgressionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.UpdateJobProgressionResponse}
 */
proto.worklayer.internal.v1.UpdateJobProgressionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 2:
      var value = /** @type {!proto.worklayer.internal.v1.JobProgressionStepStatus} */ (reader.readEnum());
      msg.setProgressionStep(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.UpdateJobProgressionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.UpdateJobProgressionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.UpdateJobProgressionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.UpdateJobProgressionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProgressionStep();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getUpdateTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.UpdateJobProgressionResponse.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.UpdateJobProgressionResponse} returns this
 */
proto.worklayer.internal.v1.UpdateJobProgressionResponse.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional JobProgressionStepStatus progression_step = 2;
 * @return {!proto.worklayer.internal.v1.JobProgressionStepStatus}
 */
proto.worklayer.internal.v1.UpdateJobProgressionResponse.prototype.getProgressionStep = function() {
  return /** @type {!proto.worklayer.internal.v1.JobProgressionStepStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.JobProgressionStepStatus} value
 * @return {!proto.worklayer.internal.v1.UpdateJobProgressionResponse} returns this
 */
proto.worklayer.internal.v1.UpdateJobProgressionResponse.prototype.setProgressionStep = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp update_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.UpdateJobProgressionResponse.prototype.getUpdateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.UpdateJobProgressionResponse} returns this
*/
proto.worklayer.internal.v1.UpdateJobProgressionResponse.prototype.setUpdateTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.UpdateJobProgressionResponse} returns this
 */
proto.worklayer.internal.v1.UpdateJobProgressionResponse.prototype.clearUpdateTime = function() {
  return this.setUpdateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.UpdateJobProgressionResponse.prototype.hasUpdateTime = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobRequest}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobRequest;
  return proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobRequest}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobRequest} returns this
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.TypeCase = {
  TYPE_NOT_SET: 0,
  NONE: 1,
  INVENTORY_ITEM: 2
};

/**
 * @return {proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.TypeCase}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.prototype.getTypeCase = function() {
  return /** @type {proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.TypeCase} */(jspb.Message.computeOneofCase(this, proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    none: (f = msg.getNone()) && google_protobuf_empty_pb.Empty.toObject(includeInstance, f),
    inventoryItem: (f = msg.getInventoryItem()) && proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse;
  return proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_empty_pb.Empty;
      reader.readMessage(value,google_protobuf_empty_pb.Empty.deserializeBinaryFromReader);
      msg.setNone(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem;
      reader.readMessage(value,proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.deserializeBinaryFromReader);
      msg.setInventoryItem(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNone();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_empty_pb.Empty.serializeBinaryToWriter
    );
  }
  f = message.getInventoryItem();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.serializeBinaryToWriter
    );
  }
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TypeCase = {
  TYPE_NOT_SET: 0,
  TAX_EXTENSION: 1
};

/**
 * @return {proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TypeCase}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.prototype.getTypeCase = function() {
  return /** @type {proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TypeCase} */(jspb.Message.computeOneofCase(this, proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    taxExtension: (f = msg.getTaxExtension()) && proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem;
  return proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension;
      reader.readMessage(value,proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension.deserializeBinaryFromReader);
      msg.setTaxExtension(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaxExtension();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension.toObject = function(includeInstance, msg) {
  var f, obj = {
    personalExtensionProgressionFlowAvailable: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    businessExtensionProgressionFlowAvailable: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    outsourcingExtensionProgressionFlowAvailable: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension;
  return proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPersonalExtensionProgressionFlowAvailable(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBusinessExtensionProgressionFlowAvailable(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOutsourcingExtensionProgressionFlowAvailable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPersonalExtensionProgressionFlowAvailable();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getBusinessExtensionProgressionFlowAvailable();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getOutsourcingExtensionProgressionFlowAvailable();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional bool personal_extension_progression_flow_available = 1;
 * @return {boolean}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension.prototype.getPersonalExtensionProgressionFlowAvailable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension} returns this
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension.prototype.setPersonalExtensionProgressionFlowAvailable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool business_extension_progression_flow_available = 2;
 * @return {boolean}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension.prototype.getBusinessExtensionProgressionFlowAvailable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension} returns this
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension.prototype.setBusinessExtensionProgressionFlowAvailable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool outsourcing_extension_progression_flow_available = 3;
 * @return {boolean}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension.prototype.getOutsourcingExtensionProgressionFlowAvailable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension} returns this
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension.prototype.setOutsourcingExtensionProgressionFlowAvailable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional TaxExtension tax_extension = 1;
 * @return {?proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.prototype.getTaxExtension = function() {
  return /** @type{?proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension, 1));
};


/**
 * @param {?proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.TaxExtension|undefined} value
 * @return {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem} returns this
*/
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.prototype.setTaxExtension = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem} returns this
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.prototype.clearTaxExtension = function() {
  return this.setTaxExtension(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem.prototype.hasTaxExtension = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Empty none = 1;
 * @return {?proto.google.protobuf.Empty}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.prototype.getNone = function() {
  return /** @type{?proto.google.protobuf.Empty} */ (
    jspb.Message.getWrapperField(this, google_protobuf_empty_pb.Empty, 1));
};


/**
 * @param {?proto.google.protobuf.Empty|undefined} value
 * @return {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse} returns this
*/
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.prototype.setNone = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse} returns this
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.prototype.clearNone = function() {
  return this.setNone(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.prototype.hasNone = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional InventoryItem inventory_item = 2;
 * @return {?proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.prototype.getInventoryItem = function() {
  return /** @type{?proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem, 2));
};


/**
 * @param {?proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.InventoryItem|undefined} value
 * @return {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse} returns this
*/
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.prototype.setInventoryItem = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse} returns this
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.prototype.clearInventoryItem = function() {
  return this.setInventoryItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.prototype.hasInventoryItem = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.ProgressionFound.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ProgressionFound.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ProgressionFound.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ProgressionFound} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProgressionFound.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    stepsList: jspb.Message.toObjectList(msg.getStepsList(),
    proto.worklayer.internal.v1.JobProgressionStep.toObject, includeInstance),
    id: jspb.Message.getFieldWithDefault(msg, 3, ""),
    progressionFlow: jspb.Message.getFieldWithDefault(msg, 4, 0),
    canChoosePersonalOrBusinessExtension: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ProgressionFound}
 */
proto.worklayer.internal.v1.ProgressionFound.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ProgressionFound;
  return proto.worklayer.internal.v1.ProgressionFound.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ProgressionFound} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ProgressionFound}
 */
proto.worklayer.internal.v1.ProgressionFound.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.v1.JobProgressionStep;
      reader.readMessage(value,proto.worklayer.internal.v1.JobProgressionStep.deserializeBinaryFromReader);
      msg.addSteps(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 4:
      var value = /** @type {!proto.worklayer.internal.v1.JobProgressionFlow} */ (reader.readEnum());
      msg.setProgressionFlow(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanChoosePersonalOrBusinessExtension(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ProgressionFound.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ProgressionFound.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ProgressionFound} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProgressionFound.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStepsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.worklayer.internal.v1.JobProgressionStep.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getProgressionFlow();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getCanChoosePersonalOrBusinessExtension();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.ProgressionFound.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ProgressionFound} returns this
 */
proto.worklayer.internal.v1.ProgressionFound.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated JobProgressionStep steps = 2;
 * @return {!Array<!proto.worklayer.internal.v1.JobProgressionStep>}
 */
proto.worklayer.internal.v1.ProgressionFound.prototype.getStepsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.JobProgressionStep>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.JobProgressionStep, 2));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.JobProgressionStep>} value
 * @return {!proto.worklayer.internal.v1.ProgressionFound} returns this
*/
proto.worklayer.internal.v1.ProgressionFound.prototype.setStepsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.worklayer.internal.v1.JobProgressionStep=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.JobProgressionStep}
 */
proto.worklayer.internal.v1.ProgressionFound.prototype.addSteps = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.worklayer.internal.v1.JobProgressionStep, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.ProgressionFound} returns this
 */
proto.worklayer.internal.v1.ProgressionFound.prototype.clearStepsList = function() {
  return this.setStepsList([]);
};


/**
 * optional string id = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.ProgressionFound.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ProgressionFound} returns this
 */
proto.worklayer.internal.v1.ProgressionFound.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional JobProgressionFlow progression_flow = 4;
 * @return {!proto.worklayer.internal.v1.JobProgressionFlow}
 */
proto.worklayer.internal.v1.ProgressionFound.prototype.getProgressionFlow = function() {
  return /** @type {!proto.worklayer.internal.v1.JobProgressionFlow} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.JobProgressionFlow} value
 * @return {!proto.worklayer.internal.v1.ProgressionFound} returns this
 */
proto.worklayer.internal.v1.ProgressionFound.prototype.setProgressionFlow = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional bool can_choose_personal_or_business_extension = 5;
 * @return {boolean}
 */
proto.worklayer.internal.v1.ProgressionFound.prototype.getCanChoosePersonalOrBusinessExtension = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.ProgressionFound} returns this
 */
proto.worklayer.internal.v1.ProgressionFound.prototype.setCanChoosePersonalOrBusinessExtension = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.GetProgressionError.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.GetProgressionError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.GetProgressionError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetProgressionError.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    error: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.GetProgressionError}
 */
proto.worklayer.internal.v1.GetProgressionError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.GetProgressionError;
  return proto.worklayer.internal.v1.GetProgressionError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.GetProgressionError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.GetProgressionError}
 */
proto.worklayer.internal.v1.GetProgressionError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 2:
      var value = /** @type {!proto.worklayer.internal.v1.GetManyProgressionErrorMessage} */ (reader.readEnum());
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.GetProgressionError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.GetProgressionError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.GetProgressionError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetProgressionError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getError();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.GetProgressionError.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.GetProgressionError} returns this
 */
proto.worklayer.internal.v1.GetProgressionError.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional GetManyProgressionErrorMessage error = 2;
 * @return {!proto.worklayer.internal.v1.GetManyProgressionErrorMessage}
 */
proto.worklayer.internal.v1.GetProgressionError.prototype.getError = function() {
  return /** @type {!proto.worklayer.internal.v1.GetManyProgressionErrorMessage} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.GetManyProgressionErrorMessage} value
 * @return {!proto.worklayer.internal.v1.GetProgressionError} returns this
 */
proto.worklayer.internal.v1.GetProgressionError.prototype.setError = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.JobProgressionStep.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.JobProgressionStep.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.JobProgressionStep} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobProgressionStep.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    progressionStep: jspb.Message.getFieldWithDefault(msg, 2, 0),
    response: jspb.Message.getFieldWithDefault(msg, 3, 0),
    dateCreated: (f = msg.getDateCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    dateResponded: (f = msg.getDateResponded()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.JobProgressionStep}
 */
proto.worklayer.internal.v1.JobProgressionStep.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.JobProgressionStep;
  return proto.worklayer.internal.v1.JobProgressionStep.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.JobProgressionStep} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.JobProgressionStep}
 */
proto.worklayer.internal.v1.JobProgressionStep.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.worklayer.internal.v1.JobProgressionStepStatus} */ (reader.readEnum());
      msg.setProgressionStep(value);
      break;
    case 3:
      var value = /** @type {!proto.worklayer.internal.v1.JobProgressionStepStatus} */ (reader.readEnum());
      msg.setResponse(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateCreated(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateResponded(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.JobProgressionStep.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.JobProgressionStep.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.JobProgressionStep} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobProgressionStep.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProgressionStep();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getResponse();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getDateCreated();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateResponded();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.JobProgressionStep.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobProgressionStep} returns this
 */
proto.worklayer.internal.v1.JobProgressionStep.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional JobProgressionStepStatus progression_step = 2;
 * @return {!proto.worklayer.internal.v1.JobProgressionStepStatus}
 */
proto.worklayer.internal.v1.JobProgressionStep.prototype.getProgressionStep = function() {
  return /** @type {!proto.worklayer.internal.v1.JobProgressionStepStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.JobProgressionStepStatus} value
 * @return {!proto.worklayer.internal.v1.JobProgressionStep} returns this
 */
proto.worklayer.internal.v1.JobProgressionStep.prototype.setProgressionStep = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional JobProgressionStepStatus response = 3;
 * @return {!proto.worklayer.internal.v1.JobProgressionStepStatus}
 */
proto.worklayer.internal.v1.JobProgressionStep.prototype.getResponse = function() {
  return /** @type {!proto.worklayer.internal.v1.JobProgressionStepStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.JobProgressionStepStatus} value
 * @return {!proto.worklayer.internal.v1.JobProgressionStep} returns this
 */
proto.worklayer.internal.v1.JobProgressionStep.prototype.setResponse = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp date_created = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.JobProgressionStep.prototype.getDateCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.JobProgressionStep} returns this
*/
proto.worklayer.internal.v1.JobProgressionStep.prototype.setDateCreated = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobProgressionStep} returns this
 */
proto.worklayer.internal.v1.JobProgressionStep.prototype.clearDateCreated = function() {
  return this.setDateCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobProgressionStep.prototype.hasDateCreated = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp date_responded = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.JobProgressionStep.prototype.getDateResponded = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.JobProgressionStep} returns this
*/
proto.worklayer.internal.v1.JobProgressionStep.prototype.setDateResponded = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.JobProgressionStep} returns this
 */
proto.worklayer.internal.v1.JobProgressionStep.prototype.clearDateResponded = function() {
  return this.setDateResponded(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.JobProgressionStep.prototype.hasDateResponded = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.JobProgressionRealtimeEvent.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.JobProgressionRealtimeEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.JobProgressionRealtimeEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.JobProgressionRealtimeEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobProgressionRealtimeEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    progressionStepsList: jspb.Message.toObjectList(msg.getProgressionStepsList(),
    proto.worklayer.internal.v1.JobProgressionStep.toObject, includeInstance),
    id: jspb.Message.getFieldWithDefault(msg, 3, ""),
    progressionFlow: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.JobProgressionRealtimeEvent}
 */
proto.worklayer.internal.v1.JobProgressionRealtimeEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.JobProgressionRealtimeEvent;
  return proto.worklayer.internal.v1.JobProgressionRealtimeEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.JobProgressionRealtimeEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.JobProgressionRealtimeEvent}
 */
proto.worklayer.internal.v1.JobProgressionRealtimeEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.v1.JobProgressionStep;
      reader.readMessage(value,proto.worklayer.internal.v1.JobProgressionStep.deserializeBinaryFromReader);
      msg.addProgressionSteps(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 4:
      var value = /** @type {!proto.worklayer.internal.v1.JobProgressionFlow} */ (reader.readEnum());
      msg.setProgressionFlow(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.JobProgressionRealtimeEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.JobProgressionRealtimeEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.JobProgressionRealtimeEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.JobProgressionRealtimeEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProgressionStepsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.worklayer.internal.v1.JobProgressionStep.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getProgressionFlow();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.JobProgressionRealtimeEvent.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobProgressionRealtimeEvent} returns this
 */
proto.worklayer.internal.v1.JobProgressionRealtimeEvent.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated JobProgressionStep progression_steps = 2;
 * @return {!Array<!proto.worklayer.internal.v1.JobProgressionStep>}
 */
proto.worklayer.internal.v1.JobProgressionRealtimeEvent.prototype.getProgressionStepsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.JobProgressionStep>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.JobProgressionStep, 2));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.JobProgressionStep>} value
 * @return {!proto.worklayer.internal.v1.JobProgressionRealtimeEvent} returns this
*/
proto.worklayer.internal.v1.JobProgressionRealtimeEvent.prototype.setProgressionStepsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.worklayer.internal.v1.JobProgressionStep=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.JobProgressionStep}
 */
proto.worklayer.internal.v1.JobProgressionRealtimeEvent.prototype.addProgressionSteps = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.worklayer.internal.v1.JobProgressionStep, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.JobProgressionRealtimeEvent} returns this
 */
proto.worklayer.internal.v1.JobProgressionRealtimeEvent.prototype.clearProgressionStepsList = function() {
  return this.setProgressionStepsList([]);
};


/**
 * optional string id = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.JobProgressionRealtimeEvent.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.JobProgressionRealtimeEvent} returns this
 */
proto.worklayer.internal.v1.JobProgressionRealtimeEvent.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional JobProgressionFlow progression_flow = 4;
 * @return {!proto.worklayer.internal.v1.JobProgressionFlow}
 */
proto.worklayer.internal.v1.JobProgressionRealtimeEvent.prototype.getProgressionFlow = function() {
  return /** @type {!proto.worklayer.internal.v1.JobProgressionFlow} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.JobProgressionFlow} value
 * @return {!proto.worklayer.internal.v1.JobProgressionRealtimeEvent} returns this
 */
proto.worklayer.internal.v1.JobProgressionRealtimeEvent.prototype.setProgressionFlow = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * @enum {number}
 */
proto.worklayer.internal.v1.GetManyProgressionErrorMessage = {
  PROGRESSION_ACCESS_DENIED: 0,
  JOB_NOT_FOUND: 1
};

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.JobProgressionStepStatus = {
  PROGRESSION_STEP_UNSPECIFIED: 0,
  JOB_STARTED: 1,
  OPEN_ITEMS: 2,
  DRAFT_IN_REVIEW: 3,
  DRAFT_REJECTED: 4,
  DRAFT_APPROVED: 5,
  NOT_STARTED: 6,
  AUTHORIZATION_REQUESTED: 7,
  AUTHORIZATION_SIGNED: 8,
  RETURN_FILED: 9,
  DELIVERABLE_COMPLETED: 10,
  PREPARATION_COMPLETED: 11,
  REVIEW_COMPLETED: 12,
  EXTENSION_IN_PROGRESS: 13,
  EXTENSION_CONFIRMED: 14,
  EXTENSION_ACCEPTED: 15,
  EXTENSION_REJECTED: 16,
  PROGRESSION_WAITING_ON_CLIENT: 17,
  READY_TO_FILE: 18
};

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.JobProgressionFlow = {
  NONE: 0,
  RETAIL: 1,
  OUTSOURCING: 2,
  ESSENTIAL: 3,
  PREPARATION: 4,
  REVIEW: 5,
  PERSONAL_EXTENSION: 6,
  BUSINESS_EXTENSION: 7,
  OUTSOURCING_EXTENSION: 8
};

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.OverrideableJobProgressionStepStatus = {
  ADMIN_RETURN_FILED: 0,
  ADMIN_JOB_STARTED: 1,
  ADMIN_OPEN_ITEMS: 2
};

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.JobProgressionExtensionType = {
  PERSONAL: 0,
  BUSINESS: 1,
  OUTSOURCING_EXTENSION_TYPE: 2
};

goog.object.extend(exports, proto.worklayer.internal.v1);
